var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFacebook = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 21,
  fill: "none",
  viewBox: "0 0 20 21",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1877F2",
  d: "M20 10.343A10 10 0 0 0 9.994.349C4.472.349 0 4.827 0 10.349a9.996 9.996 0 0 0 8.435 9.874v-6.99h-2.54v-2.89h2.54V8.14c0-2.506 1.49-3.888 3.778-3.888q1.127.016 2.237.195v2.46h-1.262a1.447 1.447 0 0 0-1.628 1.566v1.88h2.775l-.442 2.89h-2.328v6.99A10 10 0 0 0 20 10.354z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .349h20v19.874H0z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFacebook);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/facebook.d9e5b22434d0995472c7d44777cc0639.svg";